module.exports = __webpack_public_path__ + "static/img/sxglzyxy.96e2fdf6.jpg";